import styled from 'styled-components';
// import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

export const SideBox = styled.div`
  .modal_box {
    height: 100vh;
    overflow-y: scroll;
    padding-bottom: 200px;
  }

  .show {
    display: block;
  }

  .hide {
    display: none;
  }

  .order_details {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    color: #4f4f4f;
    height: 40px;
    padding-left: 20px;
    padding-right: 20px;

    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    cursor: pointer;
  }

  .date {
    width: 100%;
    height: 45px;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
  }

  .warning_text {
    color: red;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    margin-top: 5px;
    padding-left: 20px;
  }
  .button {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const Footer = styled.div`
  padding-bottom: 50px;
  margin-top: 200px;

  .delivery_date {
    width: 100%;
    height: 45px;
    border: none;
    border-radius: 5px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 14px;
    padding-right: 14px;
  }

  .option {
    margin-top: 10px;
    border-radius: 5px;
    padding: 12px;

    &:selected {
      background: #549a9a;
      color: #fff;
    }
  }
`;

export const OrderDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  height: 40px;
  padding-left: 20px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #4f4f4f;
  border-top: 1px solid #f2f2f2;
  border-bottom: 1px solid #f2f2f2;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  background: transparent;
  margin-top: 20px;
  cursor: pointer;
  padding-left: 20px;
`;

export const ItemBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  white-space: nowrap;
  height: auto;
  border-bottom: 1px solid #f2f2f2;
  margin-top: 30px;
  margin-bottom: 20px;
  padding-bottom: 20px;

  .item-name {
    color: #4f4f4f;
    font-size: 15px;
    font-weight: 500;
  }

  .price {
    font-size: 18px;
    color: #4f4f4f;
    font-weight: 600;
    font-family: Poppins;
  }

  .user-box {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    width: 40.83px;
    height: 40.83px;
    border-radius: 100%;
    background: #549a9a;
    color: #fff;
  }

  .user-box img {
    width: 48px;
    height: 48px;
    object-fit: cover;
    border-radius: 50%;
  }

  .text {
    margin-left: 5px;
    max-width: 100px;
  }

  select {
    border: 1px solid #f2f2f2;
    height: 33.91px;
    width: 57.36px;
    border-radius: 5px;
    padding-left: 5px;
    padding-right: 5px;
  }

  .image-box {
    display: flex;
    align-items: center;
    align-content: center;
  }
`;

export const SideCartBox = styled.div`
  background: rgba(84, 154, 154, 0.16);
  border-radius: 13px;
  display: flex;
  justify-content: space-between;
  height: auto;
  align-items: center;
  white-space: nowrap;

  .circle {
    width: 25px;
    height: 25px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #406767;
  }

  select {
    border: none;
    outline: none;
    background: #fff;
    border-radius: 5px;
    padding: 5px;
    color: #2c2b2b;
    font-weight: 700;
    font-size: 20px;
  }

  .flex {
    display: flex;
    align-items: center;
    align-content: center;
    flex-direction: row;
  }

  .left {
    margin-left: 5px;
    max-width: 100px;
  }

  .limit {
    width: 50px;
    border: 1px solid red;
    flex: 1;
    flex-direction: row;
    flex-wrap: wrap;
    font-size: 11px;
  }
`;

export const CouponBox = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  border: 1px solid #acd1d1;
  border-radius: 5px;
  height: 45px;
  margin-left: 21.32px;
  margin-right: 21.33px;
  margin-top: 17.57px;
  margin-bottom: 17.43px;

  input {
    width: 100%;
    height: 40px;
    border: none;
    outline: none;
    background: none;
    padding-left: 10px;
    font-size: 14px;

    ::placeholder {
      color: #4f4f4f;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .button {
    height: 45px;
    background: #549a9a;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    border-radius: 0px 5px 5px 0px;
    width: 119.72px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    cursor: pointer;
  }
`;

export const ApplyButton = styled.button`
  height: 45px;
  background: #549a9a;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  border-radius: 0px 5px 5px 0px;
  width: 119.72px;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  outline: none;

  &:disabled {
    background-color: #acd1d1;
  }
`;
export const Summary = styled.div`
  border-top: 1px solid #f2f2f2;
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 20px;
  padding-top: 20px;
  padding-right: 20px;
`;

export const Sum = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
`;

export const Scroll = styled.div`
  padding-left: 20px;
  padding-right: 20px;
`;

export const Image = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 100%;
  object-fit: center;

  @media screen and (max-width: 768px) {
    width: 60px;
    height: 60px;
    border-radius: 100%;
    object-fit: center;
  }
`;

export const PayButton = styled.button`
  outline: none;
  border: none;
  height: 45px;
  color: #fff;
  background-color: #549a9a;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  font-family: Poppins;

  &:disabled {
    background: #acd1d1;
  }
`;

export const Base = styled.div`
  color: #000;
  position: fixed;
  z-index: 100;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.65);
  display: grid;
  top: 0;
  right: 0;
  transition: 0.3s ease-in-out;
  opacity: ${({ isOpen }) => (isOpen ? '100%' : '0')};
  right: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
`;
